<div class="ero">
    <div class="eroInputs">
        <span class="eroTitle">Charge Details</span>
        <i class="flaticon-close" matTooltip="Close" matTooltipPosition="left" (click)="cancelChargesDialog()"></i>
    </div>
    <mat-dialog-content style="flex-direction: column">
        <div fxFlex="100" class="inputs" fxLayout="row wrap" [formGroup]="emptyRepoForm">
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column">
                <app-select-field [isEditable]="true" formControlName="charge_name"
                                  [name]="'charge'" [displayField]="'charge.print_name'"
                                  [searchable]="true" [label]="'Charge'"
                                  [labelItemTemplate]="userSelectedItem"
                                  [itemTemplate]="userItem"
                                  [options]="nonConsolidatedQuoteCharges" [idField]="null">
                </app-select-field>
                <ul class="errorList" *ngIf="submitted && myForm.charge_name.errors?.required">
                    <li class="error"><sup>*</sup>Please select charge name</li>
                </ul>
            </div>
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column">
                <app-mat-auto-search [isEditable]="true"
                                     formControlName="paid_to" [name]="'paid_to'"
                                     [displayField]="'legal_name'" [label]="'Paid To'"
                                     [labelItemTemplate]="userSelectedItemPaid"
                                     [itemTemplate]="userItemPaid"
                                     [idField]="null" [listUrl]="company_url+'?name=::search::'"
                                     fxLayout="column">
                </app-mat-auto-search>
                <ul class="errorList" *ngIf="submitted && myForm.paid_to.errors?.required">
                    <li class="error"><sup>*</sup>Please select paid to</li>
                </ul>
            </div>
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column">
                <app-mat-auto-search [isEditable]="true" [name]="'currency'" formControlName="currency"
                                     fxLayout="column" [listUrl]="currencyUrl" [idField]="'currency_code'"
                                     [labelItemTemplate]="userSelectedItemCur"
                                     [itemTemplate]="userItemCur" [label]="'Currency'"
                                     [displayField]="'currency_code'"
                                     class="align-items-center labelInput">
                </app-mat-auto-search>
                <ul class="errorList" *ngIf="submitted && myForm.currency.errors?.required">
                    <li class="error"><sup>*</sup>Please select Currency</li>
                </ul>
            </div>
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column" *ngIf="isCustomer && myForm.basis.value ==
            'Job'">
                <app-number-field [isEditable]="true" formControlName="rec_amount" [label]="'Amount(Rec)'"
                                  fxLayout="column" [minValue]="0">
                </app-number-field>
                <ul class="errorList" *ngIf="submitted && myForm.rec_amount.errors?.required">
                    <li class="error"><sup>*</sup>Please enter amount</li>
                </ul>
            </div>
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column" *ngIf="isCustomer">
                <!-- <div class="inputTitle"> -->
                <!--     <span>Remark(Rec)</span> -->
                <!-- </div> -->
                <app-text-field [isMultiline]="true" [isEditable]="true" [label]="'Remark(Rec)'"
                                formControlName="rec_remark" [name]="'remark'" class="m1em "
                                fxLayout="column">
                </app-text-field>
                <!-- <textarea matInput type="text" formControlName="rec_remark" [name]="'remark'" class="hw100" -->
                <!--           [id]="'remark'"> </textarea> -->
                <ul class="errorList" *ngIf="submitted && myForm.rec_remark.errors?.required">
                    <li class="error"><sup>*</sup>Please enter remarks</li>
                </ul>
            </div>
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column" *ngIf="myForm.basis.value == 'Job'">
                <app-number-field [isEditable]="true" formControlName="pay_amount" [label]="'Amount(Pay)'"
                                  fxLayout="column" [minValue]="0">
                </app-number-field>
                <ul class="errorList" *ngIf="submitted && myForm.pay_amount.errors?.required">
                    <li class="error"><sup>*</sup>Please enter amount</li>
                </ul>
            </div>
            <div fxFlex="100" fxFlex.gt-md="12.3em" fxLayout="column">
                <!-- <div class="inputTitle"> -->
                <!--     <span>Remark(Pay)</span> -->
                <!-- </div> -->
                <app-text-field [isMultiline]="true" [isEditable]="true" [label]="'Remark(Rec)'"
                                formControlName="pay_remark" [name]="'remark'" class="m1em "
                                fxLayout="column">
                </app-text-field>
                <!-- <textarea name="remark" class="hw100" placeholder="Remark(Pay)" formControlName="pay_remark" -->
                <!--           id="remark1" style="margin-top: 5px;"></textarea> -->
                <ul class="errorList" *ngIf="submitted && myForm.pay_remark.errors?.required">
                    <li class="error"><sup>*</sup>Please enter remarks</li>
                </ul>
            </div>

            <div class="setTable w-100 empty-repo-charge-table">
                <mat-table [dataSource]="chargesDataSource">
                    <ng-container matColumnDef="requirement">
                        <mat-header-cell *matHeaderCellDef>Requirement</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index">
                            {{data.requirement?.container_size_type?.display}}
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="rec_amount">
                        <mat-header-cell *matHeaderCellDef>Amount/Qty (Rec)</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index">
                            <!--                            <logzy-money-field [isEditable]="true" [(amount)]="data.rec_amount" [minValue]="0"-->
                            <!--                                               fxLayout="column" [curdisabled]="true"-->
                            <!--                                               [disabled]="myForm.basis.value == 'Job'"-->
                            <!--                                               [(currencyCode)]="data.rec_currency" class="w-100i">-->
                            <!--                            </logzy-money-field>-->
                            <app-number-field [minValue]="0" [isEditable]="true"
                                              [(ngModel)]="data.rec_amount" [ngModelOptions]="{standalone: true}"
                                              [numVal]="data.rec_currency" class="w-100i" fxFlex="15em"
                                              fxLayout="column">
                            </app-number-field>
                        </mat-cell>

                    </ng-container>
                    <ng-container matColumnDef="pay_amount">
                        <mat-header-cell *matHeaderCellDef>Amount/Qty (Pay)</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index">
                            <!-- <logzy-money-field [isEditable]="true" [(amount)]="data.pay_amount" [minValue]="0" -->
                            <!--                    fxLayout="column" [curdisabled]="true" -->
                            <!--                    [disabled]="myForm.basis.value == 'Job'" -->
                            <!--                    [(currencyCode)]="data.pay_currency" class="w-100i"> -->
                            <!-- </logzy-money-field> -->
                            <app-number-field [minValue]="0" [isEditable]="true"
                                              [(ngModel)]="data.pay_amount" [ngModelOptions]="{standalone: true}"
                                              [numVal]="data.pay_currency" class="w-100i" fxFlex="15em"
                                              fxLayout="column">
                            </app-number-field>
                        </mat-cell>

                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumnsCharges"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsCharges;"
                             [hidden]="chargesDataSource.data.length == 0"></mat-row>
                </mat-table>
            </div>
        </div>
        <mat-dialog-actions>
            <button mat-raised-button class="Cancel" (click)="cancelChargesDialog()">Close</button>
            <div class="btnb" *ngIf="!isCustomer">
                <button mat-raised-button (click)="saveChargesDetails()" class="Save"
                        [disabled]="chargesDataSource.data.length == 0">
                    <span *ngIf="!disableSave">
                        Add Charge
                    </span>
                    <div *ngIf="disableSave" class="p03">
                        <i class="flaticon-loading spin"></i>
                        <span>Saving ...</span>
                    </div>
                </button>
            </div>
        </mat-dialog-actions>
    </mat-dialog-content>
</div>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.charge?.print_name}}
        </span>
        <span class="email">
            HSN: {{item?.charge?.hsn_code?.code ?? '-'}}
        </span>
        <span class="email">
            Basis: {{item?.charge?.uom?.description}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item?.charge?.print_name}}
</ng-template>

<ng-template #userItemCur let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.currency_code}}
        </span>
        <span class="email">
<!--            {{ item?.charge?.charge_code }}-->
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItemCur let-item>
    {{item?.currency_code}}
</ng-template>

<ng-template #userItemPaid let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.legal_name}}
        </span>
        <span class="email">{{item?.address}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItemPaid let-item>
    {{item?.legal_name}}
</ng-template>
